<template>
	<div class="container">
		<div class="core-header">
			<div class="banner-top flex-row justify-between">
				<div class="top-left flex-row items-center">
					<div class="icon-location item-left flex-row items-center">
						<img src="../../assets/image/p-1.png" class="image-icon" />
						<span class="text-top">位置 - {{ webInfo.adderss }}</span>
					</div>
					<div class="icon-download item-left flex-row items-center">
						<img src="../../assets/image/p-2.png" class="image-icon" />
						<span class="text-top"><a rel="noopenner noreferrer" target="_blank" style="color: white" :href=href>APP下载</a></span>
					</div>
					<div class="icon-telephone item-left flex-row items-center" >
						<img src="../../assets/image/goPt.png" class="image-icon" />
						<a class="text-top" href='https://www.wuyouyd.com/pt/' style="color: #fff">管理端</a>
					</div>
				</div>
				<div class="top-right flex-row items-center">
          <div class="item-right flex-row items-center" @click="showLogin()">
            <span class="text-top" v-if="!$store.state.token">登录/注册</span>
          </div>
					<div class="item-right flex-row items-center" @click="jump('/ordinaryUser/deviceList')">
						<span class="text-top">收藏夹</span>

					</div>
					<div class="item-right text-top" @click="jump('/personalCenter/orderDevice')">
						留言管理
					</div>
<!--					<div class="item-right text-top" @click="jump('/personalCenter/index')" v-if="$store.state.name !== ''" >-->
<!--						个人中心-->
<!--					</div>-->
					<div class="flex-row items-center" v-if="$store.state.token">
						<span class="text-top" >{{ $store.state.name }}</span>
					</div>
					<div class="line" ></div>
					<div class="sign-out text-top" @click="logoutHandle" v-if="$store.state.token">退出</div>
				</div>
			</div>
			<div class="banner-bottom flex-row justify-between items-center" style="width: 80%;margin: 0 auto;padding: 10px 0;">
				<div class="bottom-left flex-row items-center"  @click="_userLinkLogo">
					<div style="display: flex;align-items: end;">
						<router-link to="/ordinaryUser/index">
							<img src="../../assets/image/login/index_top.png" style="width: 126px;height: 55px;" class="img-logo" />
						</router-link>

					</div>
					<div @mousedown.prevent style="display: flex; align-items: center; font-size: 17px;position: absolute;right: 5%;margin-top: 15px;">
						<!-- <div v-for="(item, i) in bannerList" :key="i" :class="i == 6 ? '' : 'banner-margin'"
							class="flex-col items-center banner-item" @click="bannerActive = i"
							style="justify-content: center">
							<span class="text-margin">{{ item.name }}</span>
							</router-link>
						</div> -->

            <div v-for="(item, index) in bannerList1" :key="'b1-' + index"
                 :class="index === bannerActive1 && 'ACTIVE flex-col items-center banner-item banner-margin' || ' flex-col items-center banner-item banner-margin'"
                 @click.stop="_userNavBaer1(item, index)" style="justify-content: end;">
              <span class="text-margin">{{ item.name }}</span>
<!--              <div v-if="item.type===5&&weidu>0" id="unread-badge">{{weidu}}</div>-->
              <!--</router-link>-->
            </div>
            <div style="width: 800px"></div>
						<div v-for="(item, index) in bannerList" :key="'b2-' + index"
							:class="index === bannerActive && 'ACTIVE flex-col items-center banner-item banner-margin' || ' flex-col items-center banner-item banner-margin'"
							@click.stop="_userNavBaer(item, index)" style="justify-content: end;">
							<span class="text-margin">{{ item.name }}</span>
<!--              <div v-if="item.type===5&&weidu>0" id="unread-badge">{{weidu}}</div>-->

							<!--</router-link>-->
						</div>
					</div>
				</div>

				<!-- <div class="bottom-right flex-row items-center">
					<img src="../../assets/image/p-5.png" class="img-search" />
					<input type="text" placeholder="搜索" placeholder-class="holderclass" class="search-input" />
				</div> -->
			</div>
		</div>
		<div class="main">
			<router-view></router-view>
		</div>

		<div class="footer">
			<div class="footer-top" style="display: flex;justify-content: space-between;">
				<div class="section-one" style="display: block;">
<!--					<div>-->
<!--						<p>快速导航</p>-->
<!--						<div style="display: flex;">-->
<!--							<div v-for="(item, i) in linkList" :key="i" class="link-item"-->
<!--								:class="i == 4 ? '' : 'link-margin'" @click="jump(item.path)">-->
<!--								{{ item.name }}-->
<!--							</div>-->
<!--						</div>-->
<!--					</div>-->
					<div>
						<p class="text-title">公司信息</p>
						<div class="text-item">
							电力用电平台项目旨在为用电客户与发电设备资源厂商之间提供一个精准连接的通道。
						</div>
					</div>
				</div>
				<img src="../../assets/image/login/index_bottom.png" style="width:230px;height: 123px;" alt=""
					 />
<!--				<div class="line-footer"></div>-->
<!--				<div class="flex-col items-center" style="margin-right: 20px;">-->
<!--					<div class="text">{{ webInfo.tel }}</div>-->
<!--					<div class="text">7×24小时客服热线</div>-->
<!--				</div>-->

			</div>
			<!--<div class="footer-bottom">备案号：{{ webInfo.websiteNumber }} <a style="margin-left: 20px;">违法信息举报电话:
					0311-66662608</a></div>-->
			<div class="footer-bottom">
        <div style="font-size: 18px;font-weight: bold;width: 100%;text-align: center ">
          访问量：<span style="color: #fe5a39">{{pcPageViewsTotal}}</span>
        </div>
<!--        <div  style="font-size: 12px;width: 100%;text-align: center;background: #f5f5f5 ">-->
<!--          © 1999-2025 wuyouyd.com-->
<!--        </div>-->
<!--				<a rel="noopenner noreferrer" target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index"  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; ">{{webInfo.websiteNumber}}</p></a>&nbsp;&nbsp;&nbsp;&nbsp;-->
				<div style="background: #f5f5f5">
          <a rel="noopenner noreferrer" target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index"  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; ">冀ICP备19025073号-5</p></a>&nbsp;&nbsp;&nbsp;&nbsp;
          <a rel="noopenner noreferrer" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13010202004389" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../../assets/image/gaba.png"  />
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; ">冀公网安备 13010202004389号</p></a>
        </div>
				<!--<a style="margin-left: 20px;"><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; ">违法信息举报电话:
				0311-66662608</p></a>-->
			</div>
		</div>

    <loginDia
        :dialogShow.sync="dialogShow"
    ></loginDia>
	</div>
</template>

<script>
import {webInfoApi, getTaskMessage, updateShareNewsIsLook, getUserWeidu, readtypechange2,queryPcTotal} from "../../http/api/user.js";
import loginDia from "./loginDia.vue"
import fa from "element-ui/src/locale/lang/fa";
import {carListApi} from "@/http/api/ordinary";

	export default {
    components: {
      loginDia
    },
		data() {
			return {
				weidu:0,
        dialogShow:false,
        shopNum:0,
        pcPageViewsTotal:0,
				// activeName: 'second',
				//bannerList中每一项加入路由路径，分发到router-link上的to属性中
				bannerList: [
            {
						name: "保电类",
						path: "/ordinaryUser/rent",
						type: 0
					},
					{
						name: "照明类",
						path: "/ordinaryUser/emergency",
						type: 1
					},
					{
						name: "其他类",
						path: "/ordinaryUser/share",
						type: 2
					},
					// {
					// 	name: "新闻资讯",
					// 	path: "/ordinaryUser/news",
					// 	type: 3
					// },
					// {
					// 	name: "活动公告",
					// 	path: "/ordinaryUser/event",
					// 	type: 4
					// },
					// /*{
					// 	name: "停电信息",
					// 	path: "/ordinaryUser/blackout",
					// 	type: 6
					// },*/
					// {
					// 	name: "联系客服",
					// 	path: "/service",
					// 	type: 5
					// },
				],
				bannerActive: null,
				linkList: [{
						name: "用电",
						path: "/ordinaryUser/index",
					},
					{
						name: "新闻资讯",
						path: "/ordinaryUser/news",
					},
					{
						name: "活动公告",
						path: "/ordinaryUser/event",
					},
					{
						name: "联系客服",
						path: "/ordinaryUser/contact",
					},
					/*{
						name: "停电信息",
						path: "/ordinaryUser/blackout",
					},*/
				],
				linkActive: 0,
				webInfo: {},
				href:window.origin+"/wyyd_1.0.apk",
        bannerActive1: null,
        bannerList1: [
            {
          name: "平台简介",
          path: "/ordinaryUser/introduction",
          type: 0
        },{
          name: "服务案例",
          path: "/ordinaryUser/serviceCase",
          type: 1
        },{
          name: "服务资源",
          path: "/ordinaryUser/serviceResources",
          type: 2
        }
        ]
			};
		},
		created() {
			const num = 1920 / 100;
			if (innerWidth <= 1152) {
				document.documentElement.style.fontSize = "60px";
			} else {
				document.documentElement.style.fontSize = innerWidth / 19.2 + "px";
			}
			this.getWebInfo();
      this.getPeople()
			// this.getMessage();
			// this.getweidu();
      // this.getList()
      this.$root.$on('resetBanner', (payload) => {
        this.bannerActive1 = payload.bannerActive1;
        this.bannerActive = payload.bannerActive;
      })
		},
    // watch: {
    //   '$route'(to, from) {
    //     // 确保路由真正发生了变化（避免同一路由重复触发）
    //     if (to.path !== from.path && this.$store.state.token) {
    //       this.getList()
    //     }
    //
    //   }
    // },
		methods: {
      // 购物车信息
      // getList() {
      //   carListApi().then(res => {
      //     // for (let arr of res) {
      //     // 	for (let item of arr.goods) {
      //     // 		item['check'] = false
      //     // 	}
      //     // }
      //     var num = 0
      //     res.forEach(item=>{
      //       num = num + item.archiveList.length
      //
      //     })
      //     this.shopNum = num
      //   })
      // },

      showLogin(){
        this.dialogShow = true
      },

			// getweidu(){
			// 	getUserWeidu({contactType:0}).then(res=>{
			// 		this.weidu=res;
			// 	})
			// },
			// logo
			_userLinkLogo() {
				this.bannerActive = null
				this.bannerActive1 = null
			},
			// 导航
			_userNavBaer(data, index) {
				if(this.weidu>0){
					readtypechange2({contactType: 0}).then(res=>{
						// console.log(res)

					})
				}

				this.bannerActive = index
				this.bannerActive1 = null
				this.$router.push({
					path: data.path + `?type${data.type}`
				})
			},
      // 导航
      _userNavBaer1(data, index) {
        this.bannerActive1 = index;
        this.bannerActive = null;
        this.$router.push({
          path: data.path + `?type${data.type}`
        })
      },
			logoutHandle() {
				this.$store.dispatch('LogOut', this.$router)
			},
			jump(link) {
        if(!this.$store.state.token){
          this.dialogShow = true
          return
        }
				this.$router.push({
					path: link,
				});
			},
			openCustomerServer() {
				this.$router.push({
					path: '/service',
					query: {
						contactType: 0,
						contactId: 1
					}
				})
			},
			getWebInfo() {
				webInfoApi().then((res) => {
					this.webInfo = res;
				});
			},
      getPeople(){
        queryPcTotal().then(res=>{

          this.pcPageViewsTotal = res.pcPageViewsTotal
        })
      },
			// getMessage(){
      //
      //
			// 	// getCountTaskMessage().then(res => {
			// 	// 	this.count = res;
			// 	// });
			// 	getTaskMessage().then(res => {
			// 		if(res.code === 200){
			// 			// this.messageData = res.rows;
			// 			res.rows.forEach((item, index) => {
			// 				let that = this;
			// 				window.setTimeout(() => {
			// 					that.$notify({
			// 						title: item.title,
			// 						message: item.message,
			// 						duration: 0,
			// 						offset: 80,
			// 						onClick(){
			// 							that.goto(res.rows[index]);
			// 							this.close(res.rows[index].id);
			// 						}
			// 					});
			// 				},10 * index );
			// 			});
			// 		}
			// 	});
			// },
			goto(row){
				updateShareNewsIsLook(row.id).then(res => {
					if(res){
						// this.getMessage();
						this.$router.push({
							path: "/orderDetail/detail",
							query:{
								id: row.needId
							}
						});
					}
				});

			}
		},
	};
</script>

<style lang="less" scoped>
#unread-badge {
	position: absolute;
	display: inline;
	top: 10px;
	right: 10px;
	background-color: red;
	color: white;
	width: 20px;
	height: 20px;
	border-radius: 100%;
	padding: 5px;
	transform: translate(-50%, -50%);
	font-weight: bold;
	font-size: 20px;
}

	// 导航激活的颜色
	.ACTIVE {
		border-bottom: 2px solid #ff5400;
	}

	.main {
		min-height: calc(100vh - 420px);
		background-color: #eeeeee;
	}

	.footer {
		background-color: #ffffff;
		height: 250px;
	}

	.banner-top {
		box-sizing: border-box;
		height: 40px;
		padding: 10px 20px;
		background-color: #41444c;
		font-size: 14px;
		color: white;
	}

	.item-left {
		margin-right: 30px;
		cursor: pointer;
	}

	.image-icon {
		width: 12px;
		height: 12px;
		margin-right: 10px;
	}

	.item-right {
		margin-right: 30px;
		cursor: pointer;
	}

	.img-user {
		width: 20px;
		height: 20px;
		margin-right: 20px;
	}

	.line {
		width: 2px;
		height: 2px;
		background-color: #c4c4c4;
		margin: 10px;
	}

	.sign-out {
		cursor: pointer;
		color: #ff5252;
	}

	/* banner-top end */
	/* banner-bottom */
	.banner-bottom {
		box-sizing: border-box;
		padding: 0.06rem 0.42rem 0.05rem 0.32rem;
	}

	.bottom-left {
		// height: 20px;
	}

	.bottom-left a {
		text-decoration: none;
		display: flex;
		justify-content: center;
	}

	.img-logo {
		width: 1.77rem;
		height: 100%;
		margin-right: 20px;
	}

	.banner-text {
		height: 60px;
		align-self: flex-end;
	}

	.banner-text a {
		font-size: 16px;
		/* line-height: 0.16rem; */
		line-height: 16px;
		color: #333333;
		text-decoration: none;
	}

	.banner-item {
		height: 40px;
		font-size: 0.18rem;
		cursor: pointer;

		a:hover {
			position: relative;

			span {
				color: #333333;
			}
		}

		.router-link-active::after {
			content: "";
			width: 0.64rem;
			height: 0.04rem;
			background: #ff5400;
			position: absolute;
			left: 50%;
			margin-left: -0.32rem;
			bottom: -0.24rem;
		}
	}

	.banner-margin {
		margin-right: 0.46rem;
	}

	.line-active {
		width: 0.64rem;
		height: 0.04rem;
	}

	.bottom-right {
		width: 4rem;
		height: 0.4rem;
		background: #f4f4f4;
		border-radius: 0.04rem;
		opacity: 1;
	}

	.img-search {
		width: 0.16rem;
		height: 0.17rem;
		margin: 0 0.17rem 0 0.14rem;
	}

	.search-input {
		height: 0.16rem;
		font-size: 0.16rem;
		padding: 0;
		border: none;
		outline: none;
		flex: 1 1 auto;
		background: #f4f4f4;
	}

	.holderclass {
		font-size: 0.16rem;
		color: #898989;
	}

	/* banner-bottom end */
	/* footer-top */
	.footer-top {
		// position: relative;
		-webkit-box-sizing: border-box;
		height: 2.49rem;
		background: #ffffff;
		// padding-right: 0.1rem;
		padding: 0 2rem;
		align-items: center;
	}

	.section-one {
		margin-right: 5.43rem;
	}

	.section-one p {
		font-size: 0.14rem;
		margin: 0;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 600;
		color: #000000;
		line-height: 0.2rem;
	}

	.section-one .text-title {
		margin-bottom: 0.14rem;
	}

	.link-item {
		font-size: 0.13rem;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #686868;
		line-height: 0.18rem;
		margin: 0.14rem 0 0.33rem;
		cursor: pointer;
	}

	.link-margin {
		margin-right: 0.28rem;
	}

	.text-item {
		width: 3.44rem;
		font-size: 0.13rem;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #686868;
		line-height: 0.23rem;
	}

	.line-footer {
		// position: absolute;
		// left: 50%;
		// top: 50%;
		// margin: -0.69rem 0 0 -0.005rem;
		width: 0.01rem;
		height: 1.38rem;
		background-color: #ebebeb;
	}

	.text {
		font-size: 0.18rem;
		font-family: PingFang SC-Semibold, PingFang SC;
		font-weight: 600;
		color: #333333;
		line-height: 0.25rem;
		margin-bottom: 0.1rem;
	}

	.call-button {
		cursor: pointer;
		width: 1.71rem;
		height: 0.32rem;
		background: #333333;
		border-radius: 0.21rem;
		font-size: 0.14rem;
		font-family: PingFang SC-Semibold, PingFang SC;
		font-weight: 600;
		color: #ffffff;
		line-height: 0.32rem;
		text-align: center;
	}

	.footer-bottom {
		height: 50px;
		background: #F5F5F5;
		font-size: 0.13rem;
		color: #5b5b5b;
		line-height: 0.5rem;
		text-align: center;
	}
</style>
